import { render } from "./HomePage.vue?vue&type=template&id=1ea534c3&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=1ea534c3&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea534c3"]])

export default __exports__